export default "__VITE_ASSET__DtqbmB0B__"